import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ContentsSection, PageTitle } from "component/app/items";
import { Footer } from "component/elements/footer";
import { Header } from "component/elements/header";
import { LoadingBox } from "component/basic/popup";
import { BoardDetailPage, BoardDetailSection } from "component/board/items";

const BoardDetail = (props) => {
    const navigate = useNavigate();
    const param = useParams();
    const id = param.id;
    const type = param.type;

    const [loadingBoxOpen,setLoadingBoxOpen] =  useState(true);

    const pageDataApi = useGet({
        url:`/${type}/detail?${type}_id=${id}`,
        loginType:"login"
    });
    const pageData = type === "event" ? pageDataApi?.data?.event : type === "notice" ? pageDataApi?.data?.notice : null;

    useEffect(() => {
        setLoadingBoxOpen(false);
    }, []);

    return (
        <>
            <ContentsSection
                header={true}
                footer={true}
                addClass={"gBg"}
            >
                <Header
                    addClass=""
                    logo={false}
                    mMenu={false}
                    pageBack={true}
                    func={()=>{navigate(-1)}}
                    headTitle={`${type === "event" ? "이벤트 " : type === "notice" ? "공지사항 " : ""}상세`}
                    rightBtnsArr={null}
                    pageClose={false}
                    activeType={pageData?.type === "insurance" ? 3 : 2}
                    closeFunc={()=>{}}
                />
                <BoardDetailPage addClass="">
                    <PageTitle
                        addClass="fixedContents_title pcItemT"
                        pageBack={()=>{navigate(-1)}}
                        contents={`${type === "event" ? "이벤트 " : type === "notice" ? (pageData?.type === "insurance" ? "자차(면책)제도 " : "공지사항 ") : ""}상세`}
                    />
                    <BoardDetailSection
                        addClass=""
                        type={type}
                        data={pageData}
                    />
                </BoardDetailPage>
            </ContentsSection>
            <Footer/>
            <LoadingBox openType={loadingBoxOpen}/>
        </>
    );
};

export default BoardDetail;